import { Skeleton, SkeletonProps } from "@clarityos/ui";
import { type ReactNode } from "react";
import { twMerge } from "tailwind-merge";

interface PatientDrawerTitleProps {
  children: ReactNode;
  end?: ReactNode;
  className?: string;
}

export function PatientDrawerTitle({
  children,
  end,
  className,
}: PatientDrawerTitleProps) {
  return (
    <div className={twMerge("flex items-center gap-2", className)}>
      <p className="typo-headline-sm m-0">{children}</p>
      {end}
    </div>
  );
}

export function PatientDrawerTitleSkeleton({
  className,
  active = true,
  ...props
}: SkeletonProps) {
  return (
    <Skeleton
      {...props}
      active={active}
      className={twMerge("h-[22px] w-[120px]", className)}
    />
  );
}
